'use client'
import { IoCloseOutline } from 'react-icons/io5'
import { useUIStore } from '@/store'
import FilterProduct from './SideFilter'

export const Sidebar = ({ menuItems, productAttr }: any) => {
  const isSideMenuOpen = useUIStore((state) => state.isSideMenuOpen)
  const closeMenu = useUIStore((state) => state.closeSideMenu)

  return (
    <div className="relative z-50">
      {/* Background black */}
      {isSideMenuOpen && (
        <div className="fixed top-0 left-0 w-screen h-screen z-10 bg-black opacity-30" />
      )}

      {/* Blur */}
      {isSideMenuOpen && (
        <div
          onClick={closeMenu}
          className="fade-in fixed top-0 left-0 w-screen h-screen z-10 backdrop-filter backdrop-blur-sm"
        />
      )}

      {/* Sidemenu */}
      <nav
        className={`fixed p-5 right-0 top-0 w-[400px] h-screen bg-white z-20 shadow-2xl transform transition-all duration-300 ${
          isSideMenuOpen ? '' : 'translate-x-full'
        }`}
      >
        <IoCloseOutline
          size={50}
          className="absolute top-5 right-5 cursor-pointer"
          onClick={() => closeMenu()}
        />

        <div className="max-w-screen-xl mx-auto px-6 bg-white">
          <div className="flex flex-col items-center mt-14 ml-18">
            <FilterProduct
              menuItems={menuItems}
              productAttr={productAttr}
              className={'overflow-y-auto max-h-[calc(100vh-110px)]'}
            />
          </div>
        </div>
      </nav>
    </div>
  )
}
